import { render } from "./OrderEdit.vue?vue&type=template&id=4985d81c&scoped=true"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"

import "./OrderEdit.vue?vue&type=style&index=0&id=4985d81c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/KAYBU/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4985d81c"]])

export default __exports__